
export const CommonTccKey = {
  // athenaCallerOpenCountryLanguages: 'athena_caller_open_country_languages',
};

// tcc 兜底配置
export const getDefaultCommonTcc = () => ({
  // 智能客服 by 国家语言配置
  // [CommonTccKey.athenaCallerOpenCountryLanguages]: [],
});
